import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from "./utility/ProtectedRoute";

import NotFound from "./pages/NotFound";

// Tuck

import Central_LoginPage from "./pages/Central_LoginPage";

//Vendor
import Vendor_Dashboard from "./pages/tuck_shop/Vendor_Dashboard";
import MenuItemList from "./pages/tuck_shop/MenuItemList";
import RetailInventory from "./pages/tuck_shop/RetailInventory";
import RetailSalesView from "./pages/tuck_shop/RetailSalesView";
import VendorStudentDirectory from "./pages/finance/VendorStudentDirectory";

//Finace
import Finance_Dashboard from "./pages/finance/Finance_Dashboard";
import Shop_Sales_View from "./pages/finance/Shop_Sales_View";
import WalletManagement from "./pages/finance/WalletManagement";
import FinanceSalesReport from "./pages/finance/FinanceSalesReport";
import WalletDailyLimits from "./pages/finance/WalletDailyLimits";
import ManualDebits from "./pages/finance/ManualDebits";
import StudentDirectory from "./pages/finance/StudentDirectory";



//ICT
import Dashboard_ict from "./pages/ICT/Dashboard_ict";
import UserManagement from "./pages/ICT/UserManagement";

function App() {
  return (
    <Router>
      <Routes>

        {/* Default / Central Auth */}
        <Route path="/"                    element={<Central_LoginPage />} />

        {/* Authentication Routes */}
     
        <Route path="/Central_LoginPage"   element={<Central_LoginPage />} />

        {/* Protected Routes */}
        <Route path="/Sch/Vendor/Dashboard" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'vendor']}> <Vendor_Dashboard /></ProtectedRoute>}/>
 <Route path="/Sch/Vendor/MenuItemList" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'vendor']}> <MenuItemList /></ProtectedRoute>}/>
 <Route path="/Sch/Vendor/RetailInventory" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'vendor']}> <RetailInventory /></ProtectedRoute>}/>
<Route path="/Sch/Vendor/RetailSalesView" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'vendor']}> <RetailSalesView /></ProtectedRoute>}/>
<Route path="/Sch/Vendor/VendorStudentDirectory" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'vendor']}> <VendorStudentDirectory /></ProtectedRoute>}/>



<Route path="/Sch/Finance/Dashboard" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'finance']}> <Finance_Dashboard /></ProtectedRoute>}/>
<Route path="/Sch/Finance/SalesView" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'finance']}> <Shop_Sales_View /></ProtectedRoute>}/>
<Route path="/Sch/Finance/WalletManagement" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'finance']}> <WalletManagement /></ProtectedRoute>}/>
<Route path="/Sch/Finance/SalesReport" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'finance']}> <FinanceSalesReport /></ProtectedRoute>}/>
<Route path="/Sch/Finance/WalletDailyLimits" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'finance']}> <WalletDailyLimits /></ProtectedRoute>}/>
<Route path="/Sch/Finance/ManualDebits" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'finance']}> <ManualDebits /></ProtectedRoute>}/>
<Route path="/Sch/Finance/StudentDirectory" element={<ProtectedRoute allowedRoles={['admin', 'ict', 'finance']}> <StudentDirectory /></ProtectedRoute>}/>


<Route path="/Sch/ICT/Dashboard_ict" element={<ProtectedRoute allowedRoles={['admin', 'ict']}> <Dashboard_ict /></ProtectedRoute>}/>
<Route path="/Sch/ICT/UserManagement" element={<ProtectedRoute allowedRoles={['admin', 'ict']}> <UserManagement /></ProtectedRoute>}/>

 
        {/* 404 - Catch all unmatched routes */}
        <Route path="*" element={<NotFound />} />

      </Routes>
    </Router>
  );
}

export default App;